export const openLinkOnNewTab = (url: string, newTab: boolean = true) => {
  if (newTab) {
    // Create a temporary anchor element for better Safari iOS compatibility
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    // Try window.open first (works in most cases when called from user interaction)
    const newPage = window.open(url, '_blank', 'noopener,noreferrer');

    // If window.open fails (blocked by popup blocker), fall back to anchor click
    if (!newPage || newPage.closed || typeof newPage.closed === 'undefined') {
      // Temporarily add to DOM, click, then remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } else {
    // For same tab navigation, use location.href which is more reliable on iOS
    window.location.href = url;
  }
};
